/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import * as ReactDOM from "react-dom";
import CopyTextUtils from "dc-preview-utils/src/Utils/CopyTextUtils";
import { isSinglePageMode } from "selectors/documentSelectors";
import { getAccessibleComponentToRender } from "components/accessibility/AccessibilityComponentHelper";
import { RICH_TEXT_DIV_ID } from "constants/constants";

export const FormattedCopyContext = React.createContext(false);

const GetHTMLforAccessibilityNodes = pagesArray => (
  <FormattedCopyContext.Provider value>
    <React.Fragment>
      {pagesArray.map((pageAccNodes, pageIndex) => (
        <React.Fragment>
          {pageAccNodes.map(({ node }, index) => getAccessibleComponentToRender(node, 1, index, pageIndex))}
        </React.Fragment>
      ))}
    </React.Fragment>
  </FormattedCopyContext.Provider>
);

export const copyTextToClipboard = (text, stores) => {
  let parentElementRef = null;
  if (isSinglePageMode(stores)) {
    parentElementRef = stores.pagedViewState.pagesViewElementHandle;
  } else {
    parentElementRef = document.body;
  }
  CopyTextUtils.copyTextToClipboard(text, parentElementRef);
};

export const copyRichTextToClipboard = (text, richText) => {
  const richTextContainer = document.createElement("div");
  richTextContainer.id = RICH_TEXT_DIV_ID;
  document.body.appendChild(richTextContainer);
  ReactDOM.render(GetHTMLforAccessibilityNodes(richText), richTextContainer);
  CopyTextUtils.copyTextWithFormattingToClipboard(text, RICH_TEXT_DIV_ID);
  richTextContainer.remove();
};
